import CourseComponent from "./CourseComponent";
import StaffComponent from "./StaffComponent";
import { Alert } from "@mui/material";
import { useState } from "react";

function OwnCourseAssignmentComponent() {
  let [alertselfassignFailed, setalertselfassignFailed] = useState(false);

  return (
    <div>
      <div>
        {alertselfassignFailed == true && (
          <Alert
            sx={{
              fontSize: "18px",
              fontWeight: "500",
              marginTop: "10px",
              marginBottom: "10px",
            }}
            severity="warning"
          >
            Can't Remove from Self Assignment while you have assigned for a
            group!
          </Alert>
        )}
      </div>
      <div
        className="wholeContainer"
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          height: "650px",
          overflowY: "scroll",
        }}
      >
        <div className="courseDivContainer">
          <CourseComponent
            setalertselfassignFailed={setalertselfassignFailed}
          />
        </div>
        <div className="staffDivContainer">
          <StaffComponent />
        </div>
      </div>
    </div>
  );
}

export default OwnCourseAssignmentComponent;
